export default "__VITE_ASSET__ByEMD9Pw__"